import React from 'react';
import {
  StyledButtonMedium,
  StyledButtonMediumDisabled,
  StyledButtonMediumOutlined,
} from './styled.buttonMedium';
import { IButton } from './../../../../@types/button';
import { Loading } from './../../../icons/Loading';
import { Headline6 } from '../../../../../app/common/typography';

export function ButtonMedium ({
  title,
  onClick,
  outlined,
  backgroundColor,
  inverted,
  disabled,
  loading,
  textColor,
  rounded,
  leftIcon,
  rightIcon,
}: IButton) {
  // title -> text inside the button
  // onClick -> function sent to parent
  // outlined -> if the button has outlined, the value must be TRUE (by default FALSE / 1px withe)
  // backgroundColor -> button color (follow the color in theme/default.ts)
  // inverted -> variable to invert the colors, this means, backgroundColor becomes outlineColor and backgroundColor becomes withe
  // disabled -> should be TRUE if the button is disabled

  if (disabled) {
    return (
      <StyledButtonMediumDisabled rounded={rounded}>
        {leftIcon || <span />}
        <Headline6 color="white">{title}</Headline6>
        {rightIcon || <span />}
      </StyledButtonMediumDisabled>
    );
  }

  if (outlined) {
    return (
      <StyledButtonMediumOutlined
        onClick={onClick}
        inverted={inverted}
        backgroundColor={backgroundColor}
        disabled={loading}
        textColor={textColor}
        rounded={rounded}
        loading={loading}
      >
        {loading ? (
          <Loading color={backgroundColor} size="m" />
        ) : (
          <>
            {leftIcon || <span />}
            <Headline6
              color={inverted ? backgroundColor : textColor || 'white'}
            >
              {title}
            </Headline6>
            {rightIcon || <span />}
          </>
        )}
      </StyledButtonMediumOutlined>
    );
  }

  return (
    <StyledButtonMedium
      onClick={onClick}
      backgroundColor={backgroundColor}
      disabled={loading}
      rounded={rounded}
      textColor={textColor}
      loading={loading}
    >
      {loading ? (
        <Loading size="m" />
      ) : (
        <>
          {leftIcon || <span />}
          <Headline6 color={textColor || 'white'}>{title}</Headline6>
          {rightIcon || <span />}
        </>
      )}
    </StyledButtonMedium>
  );
}
